const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['報表', '報表', '報表'],
				children: {
					ZZ_KANGDA_REPORT: {
						name: ['(客製)報表', '(客製)報表', '(客製)報表'],
						url: '/zz_kangda_report',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};